import rules from "../../Data/Rules"

// URL 
// Example: http://localhost:8080/?Portal=Ind_File&Contact=144
// Parameters:
// Portal=Ind_File as this is the File Portal
// Contact - Is the Contact_id to load against in Contact Details


const Documents = [
    { Type: 1867, Document: "BA Approval Notice" },
    { Type: 1867, Document: "BA Integrity Gambling & Match Fixing Certificate" },
    { Type: 257, Document: "Blue Card" },
    { Type: 1867, Document: "BA Safeguarding Children in Basketball" },
    { Type: 1867, Document: "Coaching Course Certificate" },
    { Type: 1867, Document: "Coaching Resume" },
    { Type: 1867, Document: "Medical Certificate" },
    { Type: 1867, Document: "NBL1 Annual Update 2026 Certificate" },
    { Type: 1867, Document: "Passport or proof of Citizenship" },
    { Type: 3367, Document: "Profile Picture" },
    { Type: 1867, Document: "Proof Notification of Clearance" },
    { Type: 1867, Document: "SIA Annual Update 2026 Certificate" },
    { Type: 1867, Document: "U16 Signed Indeminity Form" },
]

const Logo = {
    NBL1South: 'NBL1South.png',
    NBL1North: 'NBL1North.png',
    NBL1East: 'NBL1East.png',
    NBL1Central: 'NBL1Central.png',
    NBL1West: 'NBL1West.png',
    NBL1: 'NBL1.png',
    BIGV: 'BigVLogoNew.png',
    OUG: 'logo.png',
}


// Load Models
const LoadModel = async (Passed) => {
    let result = {
        Portal: 'File Upload',
        MainColor: "#f5924c",
        Logo: require(`../../assets/NBL1.png`), //require(`../../assets/${Conference.logo}`),
        Title: `<h2>Upload a copy of your Document to your Profile</h2>`,
        Description: ``,
        Model: {},
        steps: [
            // Step 1
            {
                stepno: 1,
                title: 'File Details',
                valid: true,
                information: `Document Type`,
                Model: {},
                Schema: {
                    Document: {
                        type: "select",
                        label: "Document",
                        outlined: true,
                        dense: true,
                        returnObject: true,
                        itemText: 'Document',
                        col: 12,
                        class: 'mx-1 px-1',
                        rules: [rules.requiredMsg('Document Type Selection is Required')],
                        items: Documents,
                        onInput: async (ev, portal) => {
                            portal.Model.Contact_id = Passed.Contact
                            portal.steps[0].Schema.File.OUG.Contact_Details.Description = ev.data.Document.Document
                            portal.steps[0].Schema.File.OUG.Contact_Details.Type = ev.data.Document.Type
                        }
                    },
                    Contact_id: {
                        type: 'number',
                        label: 'Contact id',
                        outlined: true,
                        dense: true,
                        hidden: true,
                        rules: [],
                        class: 'mx-1 px-1',
                        OUG: { Contacts: { Field: "Contact_id" } }
                    },
                    File: {
                        type: 'file',
                        label: 'File to Upload',
                        multiple: false,
                        outlined: true,
                        multiple: false,
                        dense: true,
                        accept: "image/*,application/pdf",
                        col: 12,
                        rules: [rules.requiredMsg('File to Upload is Required'), rules.fileSize()],
                        class: 'mx-1 px-1',
                        OUG: {
                            Contact_Details: {
                                Type: Number(Passed.Type),
                                Action: "SingleDesc",
                                Description: Passed.Desc,
                            }
                        },
                    },
                },
            },
            // Step 2
            {
                stepno: 2,
                title: 'Finalisation',
                valid: true,
                information: `Thank you for loading your file - you can find a copy on the App under Profile -> Documents`,
                Model: {},
                Schema: {}
            }
        ]
    }
    // Load the Model with step elements
    result.steps.forEach(element => {
        element.Model = result.Model
    });
    return result
}

export default {
    init: async (Parameters) => {
        Parameters.Desc = Documents[Parameters.Document]
        Parameters.Logo = Logo[Parameters.Client]
        let result = await LoadModel(Parameters)
        return result;
    },
}